import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store';
import createApp from '@shopify/app-bridge';
import { History } from '@shopify/app-bridge/actions';
import { getShopInfo } from "@/api/auth";
import { isRouter, isCharge } from '@/utils/auth'
import promotionApi from "@/api/promotion";
import { sessionRead } from '@/utils/util'

Vue.use(VueRouter)

export const routes = [
  {
    path: '/auth',
    name: 'auth',
    hidden: true,
    component: view('auth/Auth'),
    meta: {
      title: 'BOGO Cross Sell&Upsell bundles',
      urlStatus: '/auth'
    }
  },
  {
    path: '/started',
    name: 'started',
    hidden: false,
    component: view('get-started/index'),
    meta: {
      title: 'Getting started',
      urlStatus: '/started'
    }
  },
  {
    path: '/Dashboard',
    hidden: false,
    component: view('dashboard/DashboardView'),
    children: [
      {
        path: 'all',
        name: 'all',
        hidden: false,
        component: view('dashboard/Dashboard'),
        meta: {
          title: 'Dashboard',
          urlStatus: '/dashboard'
        }
      },
      {
        path: ':id?',
        name: 'Dashboard',
        hidden: true,
        component: view('dashboard/Dashboard'),
        meta: {
          title: 'Dashboard',
          urlStatus: '/dashboard'
        }
      }
    ],
  },
  {
    path: '/offer',
    hidden: false,
    component: view('offer/PromotionView'),
    children: [
      {
        path: 'promotionList/:default?',
        name: 'promotionList',
        hidden: false,
        component: view('offer/PromotionList'),
        meta: {
          title: 'Offers',
          urlStatus: '/offer'
        }
      },
      {
        path: 'addPromotion/:id?/:type?',
        name: 'addPromotion',
        hidden: true,
        component: view('offer/NewAddPromotion'),
        meta: {
          title: 'AddPromotion',
          urlStatus: '/offer'
        }
      },
      {
        path: 'promotionPreview/:id?/:displayPage?',
        name: 'promotionPreview',
        hidden: true,
        component: view('offer/review'),
        meta: {
          title: 'promotionPreview',
          urlStatus: '/offer'
        }
      }
    ],
  },
  {
    path: '/versionLog',
    name: 'versionLog',
    hidden: false,
    component: view('version/index'),
    meta: {
      title: 'What\'s New',
      urlStatus: '/versionLog'
    }
  },
  {
    path: '/plan',
    name: 'Plan',
    hidden: false,
    component: view('plan/ServicePlan'),
    meta: {
      title: 'Plan',
      urlStatus: '/plan'
    }
  },
  {
    path: '/404',
    name: '404',
    hidden: true,
    component: view('not-found/index'),
    meta: {
      title: 'Page Not Found'
    }
  },
  { path: '*', redirect: '/404', hidden: true }
]

const router = new VueRouter({
  mode: 'history',
  routes,//请注意这里使用了语法糖，完整写法应该是 routes: routes
})

// 路由全局前置守卫
// https://router.vuejs.org/zh/guide/advanced/navigation-guards.html#全局前置守卫
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title 添加对手机屏幕的自适应代码 */
  if (to.meta.title) {
    document.title = to.meta.title
    document.querySelector("meta[name='viewport']")["content"] = "width=device-width,initial-scale=1.0,maximum-scale=1.0,minimum-scale=1.0"
  }

  if (store.state.shopifyAppObj !== null) {
    const history = History.create(store.state.shopifyAppObj);
    history.dispatch(History.Action.PUSH, to.path);
  }
  let arr = ['/started', '/Dashboard/all', '/versionLog', '/offer', '/plan', '/service'];
  let authFlag = false;
  arr.map(item => {
    if (to.path.indexOf(item) != -1) {
      authFlag = true;
    }
  })
  
  if (store.state.currencySymbol == null && authFlag && to.path != '/auth') {
    // 获取App是否安装
    promotionApi.isPostPurchaseAppInUse().then((res) => {
      if (res.data.code === 0) {
        store.commit("setPostPurchaseActive", res.data.data.is_post_purchase_app_in_use);
      }
    });
  }

  if (to.query.shop && to.query.host && to.query.hmac && !sessionRead('host') && authFlag) {
    isRouter(to, '', 'main');
  }

  if (to.query.charge_id) {
    isCharge(to)
  }
  
  next();
})

router.afterEach(() => {
  //跳转后，返回顶部页面
  window.scrollTo(0, 0);
})

function view(name) {
  return resolve => require(['@/views/' + name + '.vue'], resolve);
}

export default router
